import { createRef } from "react";
import Shrtr from "../pages/Shrtr";

// feature routes
export const routes = [
  {
    path: "/shrtr",
    element: <Shrtr />,
    handle: {
      name: "Shrtr",
      nodeRef: createRef(),
    },
  },
];
